// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `span.resizeable-window-titlebar-control.resizeable-window-titlebar-control-disabled,
span.resizeable-window-titlebar-extra-control.resizeable-window-titlebar-control-disabled {
    opacity: 0.35;
    cursor: default;
}

/* Accordion docking: docked windows are positioned by JS (inline transform); collapsed ones are a 35px title bar */
div.customresizeable-window-docked {
    box-sizing: border-box;
}

div.resizeable-window.customresizeable-window-docked-minimized {
    height: 35px !important;
    min-height: 35px !important;
}

div.customresizeable-window-docked-minimized div.resizeable-window-titlebar {
    flex: 0 0 35px;
    height: 35px;
    cursor: pointer;
    border-radius: var(--border-radius);
}

div.customresizeable-window-docked-minimized div.resizeable-window-body {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./js/overwrite/components/style/CustomResizeableWindow.css"],"names":[],"mappings":"AAAA;;IAEI,aAAa;IACb,eAAe;AACnB;;AAEA,mHAAmH;AACnH;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,aAAa;AACjB","sourcesContent":["span.resizeable-window-titlebar-control.resizeable-window-titlebar-control-disabled,\nspan.resizeable-window-titlebar-extra-control.resizeable-window-titlebar-control-disabled {\n    opacity: 0.35;\n    cursor: default;\n}\n\n/* Accordion docking: docked windows are positioned by JS (inline transform); collapsed ones are a 35px title bar */\ndiv.customresizeable-window-docked {\n    box-sizing: border-box;\n}\n\ndiv.resizeable-window.customresizeable-window-docked-minimized {\n    height: 35px !important;\n    min-height: 35px !important;\n}\n\ndiv.customresizeable-window-docked-minimized div.resizeable-window-titlebar {\n    flex: 0 0 35px;\n    height: 35px;\n    cursor: pointer;\n    border-radius: var(--border-radius);\n}\n\ndiv.customresizeable-window-docked-minimized div.resizeable-window-body {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
